import { FC } from "react";

import Router from "@/helpers/router";
import { ValueOfObjectFields } from "shared/lib/interfaces/utils";
import { UTMLink } from "@/components/base/utm-link";

type LogoVariationI = ValueOfObjectFields<typeof LOGO_VARIATION>;

interface LogoPropsI {
  variation?: LogoVariationI;
  width?: string;
  className?: string;
  href?: string;
}

export const LOGO_VARIATION = {
  DEFAULT: "default",
  LIGHT: "default",
  DARK: "dark",
  WHITE: "white",
  BLACK: "black",
  SMALL_WHITE: "small_white",
} as const;

export const LOGO_VARIATION_MAP = {
  [LOGO_VARIATION.DEFAULT]:
    "https://glencoco-assets.s3.amazonaws.com/logos/v2/logo-glencoco-v2-default.svg",
  [LOGO_VARIATION.WHITE]:
    "https://glencoco-assets.s3.amazonaws.com/logos/v2/logo-glencoco-v2-mono-white.svg",
  [LOGO_VARIATION.BLACK]:
    "https://glencoco-assets.s3.amazonaws.com/logos/v2/logo-glencoco-v2-mono-black.svg",
  [LOGO_VARIATION.DARK]:
    "https://glencoco-assets.s3.amazonaws.com/logos/v2/logo-glencoco-v2-dark.svg",
  [LOGO_VARIATION.SMALL_WHITE]:
    "https://glencoco-assets.s3.amazonaws.com/logos/logo-glencoco-sm-white.png",
};

const getLogoSrc = (variation?: LogoVariationI) => {
  return (
    LOGO_VARIATION_MAP[variation as LogoVariationI] ||
    LOGO_VARIATION_MAP[LOGO_VARIATION.DEFAULT]
  );
};

export const Logo: FC<LogoPropsI> = ({ variation, width, className, href }) => (
  <UTMLink href={href || Router.home()} className={className}>
    <img
      src={getLogoSrc(variation)}
      alt="Glencoco Logo"
      width={width || "89px"}
    />
  </UTMLink>
);
